import React from 'react'
import ReactDOM from 'react-dom/client'
// scroll bar
import 'simplebar/src/simplebar.css'
import 'react-toastify/dist/ReactToastify.css'
import { Provider as ReduxProvider } from 'react-redux'

import { HelmetProvider } from 'react-helmet-async'
import { CollapseDrawerProvider } from '@src/contexts/CollapseDrawerContext'
import { BrowserRouter } from 'react-router-dom'
import { PostHogProvider } from 'posthog-js/react'

import App from './App'
import store from './store/store'
import i18n from './i18n'

const apiKey = process.env.REACT_APP_POSTHOG_KEY

if (!apiKey) {
  console.warn('Missing PostHog API key in environment variables')
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

i18n.init().then(() => {
  root.render(
    <>
      {apiKey ? (
        <React.StrictMode>
          <PostHogProvider
            apiKey={apiKey}
            options={{
              api_host: 'https://us.i.posthog.com',
              debug: process.env.MODE === 'development',
            }}
          >
            <HelmetProvider>
              <BrowserRouter>
                <ReduxProvider store={store}>
                  <CollapseDrawerProvider>
                    <App />
                  </CollapseDrawerProvider>
                </ReduxProvider>
              </BrowserRouter>
            </HelmetProvider>
          </PostHogProvider>
        </React.StrictMode>
      ) : (
        <HelmetProvider>
          <BrowserRouter>
            <ReduxProvider store={store}>
              <CollapseDrawerProvider>
                <App />
              </CollapseDrawerProvider>
            </ReduxProvider>
          </BrowserRouter>
        </HelmetProvider>
      )}
    </>,
  )
})
